import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accessTokenKey, baseUrl } from "../utils/config";

function SignUp() {

    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    async function signup() {
        setSubmitting(true);

        try {
            const form = document.getElementById("form-signup");
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/register",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Sign Up", response.data.message, "success")
                    .then(function () {
                        navigate("/login");
                    }); 
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Sign Up</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Sign Up</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Sign Up</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-5 text-center">Create an account and start posting jobs or start applying on jobs.</p>

                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    signup();
                                } } id="form-signup">
                                    <div className="row g-3">
                                        <div className="offset-md-3 col-md-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" name="name" placeholder="Name" required />
                                                        <label>Name</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-3 mb-3">
                                                    <div className="form-floating">
                                                        <input type="email" className="form-control" name="email" placeholder="Email" required />
                                                        <label>Email</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-floating">
                                                        <input type="password" className="form-control" name="password" placeholder="Password" required />
                                                        <label>Password</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-3 mb-3">
                                                <div className="offset-md-4 col-md-6">
                                                    <label>
                                                        Recruiter&nbsp;
                                                        <input type="radio" name="type" value="recruiter" required />
                                                    </label>

                                                    <label className="ms-5">
                                                        Job seeker&nbsp;
                                                        <input type="radio" name="type" value="job_seeker" required />
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <button className="btn btn-primary w-100 py-3" type="submit"
                                                        disabled={ submitting }>Sign Up</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SignUp;